import React, { forwardRef } from 'react';
import uuid from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    const id = uuid.v4();

    return (
        <SvgIcon ref={ref} {...props}>
            <g clipPath={`url(#${id})`}>
                <path d='M23.6137 9.905L21.7515 11.8279L23.6137 13.7508C24.1288 14.2826 24.1288 15.1418 23.6137 15.6737C23.0986 16.2055 22.2666 16.2055 21.7515 15.6737L19.8894 13.7508L18.0272 15.6737C17.5122 16.2055 16.6801 16.2055 16.1651 15.6737C15.65 15.1418 15.65 14.2826 16.1651 13.7508L18.0272 11.8279L16.1651 9.905C15.65 9.37314 15.65 8.51397 16.1651 7.98211C16.6801 7.45025 17.5122 7.45025 18.0272 7.98211L19.8894 9.905L21.7515 7.98211C22.2666 7.45025 23.0986 7.45025 23.6137 7.98211C24.1288 8.50034 24.1288 9.37314 23.6137 9.905ZM19.8762 15.6873L21.1308 16.9829V21.265C21.1308 23.2425 19.163 24.5653 17.4197 23.7607L4.8469 17.9784H2.64135C1.18861 17.9784 0 16.751 0 15.2509V9.79592C0 8.2958 1.18861 7.06842 2.64135 7.06842H4.8469L17.2613 0.317859C19.0178 -0.636764 21.1308 0.672418 21.1308 2.73168V6.68658L19.8762 7.98211L18.4895 6.55019V3.71358C18.4895 3.20899 17.9744 2.88172 17.5386 3.09992L10.5654 6.70019L7.92406 8.06393V15.6055L10.5654 16.9692L17.5386 20.5695C17.9744 20.8014 18.4895 20.4604 18.4895 19.9558V17.1192L19.8762 15.6873ZM5.28271 9.78227H3.96203C3.23566 9.78227 2.64135 10.396 2.64135 11.146V13.8735C2.64135 14.6236 3.23566 15.2373 3.96203 15.2373H5.28271V9.78227Z' />
            </g>
            <defs>
                <clipPath id={id}>
                    <rect width='24' height='24' />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});
